import { useEffect } from 'react';
import { HiOutlineDocumentText } from 'react-icons/hi2';
import { Link } from 'react-router-dom';
import ShareButton from './ShareButton';

type DocumentDetailsViewProps = {
    title: string;
    description?: string;
    downloadUrl?: string;
    backTo: string;
    backLabel: string;
};

const DocumentDetailsView: React.FC<DocumentDetailsViewProps> = ({ title, description, downloadUrl, backTo, backLabel }) => {
    useEffect(() => {
        const previousTitle = document.title;
        document.title = `${title} | FLAG`;
        return () => { document.title = previousTitle; };
    }, [title]);

    return (
        <article className="mx-2 my-6 max-w-4xl rounded-xl bg-white p-5 sm:p-8 lg:mx-auto lg:my-[10vh]">
            <Link className="text-sm text-gray-600 hover:text-primary hover:underline" to={backTo}>{backLabel}</Link>
            <div className="mt-6 flex items-start gap-4">
                <HiOutlineDocumentText aria-hidden="true" className="shrink-0 text-red-800" size={56} />
                <div>
                    <h1 className="text-2xl font-medium text-gray-900 lg:text-3xl">{title}</h1>
                    {description ? <p className="mt-4 leading-7 text-gray-600">{description}</p> : null}
                </div>
            </div>
            <div className="mt-8 flex flex-wrap gap-3 border-t border-gray-200 pt-5">
                {downloadUrl ? (
                    <a className="customButton text-sm" href={downloadUrl} download>Télécharger le document</a>
                ) : <p className="text-sm text-gray-500">Aucun fichier n'est associé à ce document.</p>}
                <ShareButton title={title} />
            </div>
        </article>
    );
};

export default DocumentDetailsView;
